import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppUppyFile } from "common";
import { RequiredDocument } from '../../model/application-form.model';
import { UploadFileDialogComponent } from '../upload-file-dialog/upload-file-dialog.component';
import { UppyFileChangeTypeEnum } from '../upload-file-dialog/upload-file.model';

@Component({
    selector: 'ifm-upload-document-list-item',
    templateUrl: './upload-document-list-item.component.html',
    styleUrls: ['./upload-document-list-item.component.scss'],
    standalone: false
})
export class UploadDocumentListItemComponent implements OnChanges {
  @Input() currentDocument: RequiredDocument;
  @Input() parentObjectId: number;
  @Input() maxNumberOfFiles: number;
  @Output() documentFilesChanged = new EventEmitter<AppUppyFile[]>();

  public tempFiles: AppUppyFile[];

  constructor(private dialog: MatDialog) {
    this.tempFiles = [];
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.currentDocument) {
      this.tempFiles = [];
      this.documentFilesChanged.emit(this.tempFiles);
    }
  }

  public openUploadDialog() {
    if (this.maxNumberOfFiles < 1) {
      return;
    }

    UploadFileDialogComponent.show(this.dialog, {
      files: this.tempFiles,
      maxNumberOfFiles: this.maxNumberOfFiles,
      getMetaCallback: () => {
        return {
          category: this.currentDocument.category,
          requirementDocumentId: this.currentDocument.id,
          parentObjectId: this.parentObjectId
        };
      }
    }).subscribe((result) => {
      if (
        result &&
        result.type &&
        result.type != UppyFileChangeTypeEnum.Canceled
      ) {
        this.tempFiles = result.files;
        this.documentFilesChanged.emit(this.tempFiles);
      }
    });
  }
}
